export default __webpack_public_path__ + "static/media/phaphrom_img3.5733ffdf.webp";